import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';
import { rgba } from 'polished';

import { Popover } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';
import PrimaryButton from 'packages/kakapo-ui-kit/components/buttons/PrimaryButton';
import OutlineButton from 'packages/kakapo-ui-kit/components/buttons/OutlineButton';
import Spinner from 'packages/kakapo-ui-kit/components/common/Spinner';
import { ButtonSize } from 'packages/kakapo-ui-kit/types/Button';

const Container = styled(Flex)`
	border-radius: 6px;
	background: ${(props) => rgba(props.theme.colors.primary, 0.1)};
	color: ${(props) => props.theme.colors.primary};
	min-height: 46px;
`;

export default function TalentReviewChanges(props: {
	count: number;
	loading: boolean;
	onSave: (status: graphql.TalentReviewStatus) => void;
}) {
	const { t } = useTranslation();
	const [visible, setVisible] = useState(false);

	return (
		<Container p={2} alignItems="center">
			<Box flexGrow={1} flexShrink={1}>
				{props.loading
					? t('talentReviews.edit.pendingChanges.loading')
					: props.count > 0
					? t('talentReviews.edit.pendingChanges.summary', { count: props.count })
					: t('talentReviews.edit.pendingChanges.finish')}
			</Box>
			{props.loading ? (
				<Spinner isLoading size="18px" verticalMargin={0} />
			) : (
				<>
					{props.count > 0 ? (
						<Box flexGrow={0} flexShrink={0} ml={2}>
							<OutlineButton
								color="primary"
								size={ButtonSize.Small}
								onClick={() => props.onSave(graphql.TalentReviewStatus.Draft)}
							>
								{t('talentReviews.edit.pendingChanges.saveAsDraftButton')}
							</OutlineButton>
						</Box>
					) : (
						<Popover.Confirm
							visible={visible}
							title={t('talentReviews.edit.pendingChanges.areYouSure')}
							confirmTitle={t('talentReviews.edit.pendingChanges.sureButton')}
							cancelTitle={t('talentReviews.edit.pendingChanges.cancelButton')}
							onCancel={() => setVisible(false)}
							onConfirm={() => {
								props.onSave(graphql.TalentReviewStatus.Shared);
								setVisible(false);
							}}
						>
							<PrimaryButton size={ButtonSize.Small} onClick={() => setVisible(true)}>
								{t('talentReviews.edit.pendingChanges.completeButton')}
							</PrimaryButton>
						</Popover.Confirm>
					)}
				</>
			)}
		</Container>
	);
}
